import * as event from "./event";
import * as fetchEvent from "./fetchEvent";
import { initialState as eventInitialState, EventRequestInfoState } from "./event";
import { initialState as fetchEventInitialState, FetchEventInfoState } from "./fetchEvent";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...event.Types,
    ...fetchEvent.Types
};

export const Actions: { event: typeof event.Actions, fetchEvent: typeof fetchEvent.Actions } = {
    event: event.Actions,
    fetchEvent: fetchEvent.Actions
};

export const eventRequestReducer = reduceReducers<EventRequestInfoState>(
    eventInitialState,
    event.default as any
);

export const fetchEventRequestReducer = reduceReducers<FetchEventInfoState>(
    fetchEventInitialState,
    fetchEvent.default as any
);

export default {
    event: eventRequestReducer,
    fetchEvent: fetchEventRequestReducer
};